import { getSHA256Hash } from '../helper/hash'

const initiateTikTokPixel = () => {

    // take from nuxt config file
    const pixel = 'CRMM1MBC77U40MO99EJG'
    const t = 'ttq';

    const { onLoaded } = useScript({
        key: 'tiktok',
        id: 'tiktok',
        type: 'text/javascript',
        src: 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + pixel + '&lib=' + t,
        // 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=CRMM1MBC77U40MO99EJG&lib=ttq'

        clientInit: import.meta.server
            ? undefined
            : () => {

                const w = window;
                w.TiktokAnalyticsObject = t;

                var ttq = w[t] = w[t] || [];

                ttq.methods = [
                    "page", "track", "identify", "instances", "debug", "on", "off",
                    "once", "ready", "alias", "group", "enableCookie", "disableCookie",
                    "holdConsent", "revokeConsent", "grantConsent"
                ];

                ttq.setAndDefer = function (target, methodName) {
                    target[methodName] = function () {
                        target.push([methodName].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                };

                for (var i = 0; i < ttq.methods.length; i++) {
                    ttq.setAndDefer(ttq, ttq.methods[i]);
                }

                ttq.instance = function (id) {
                    var inst = ttq._i[id] || [];
                    for (var n = 0; n < ttq.methods.length; n++) {
                        ttq.setAndDefer(inst, ttq.methods[n]);
                    }
                    return inst;
                };

                // ttq.load('CRMM1MBC77U40MO99EJG');
                ttq.page();

                return ttq
            },
    },
        {
            use: () => window.ttq

        }
    );

    onLoaded((ttq) => {
        // console.log('🚀 tiktok pixel loaded', ttq)
    })

}

const intiateClickAdsPixel = () => {

    const runtimeConfig = useRuntimeConfig()

    const clickads_token = runtimeConfig.public.clickads_token
    // const clickads_token = 'epLeAoMQdSNwv2mzeokS6A' // runtimeConfig.public.clickads_token
    if ([false, 'false'].includes(clickads_token)) {
        return
    }

    const { proxy, onLoaded, status } = useScript({
        id: 'clickad',
        type: 'text/javascript',
        src: 'https://tags.srv.stackadapt.com/events.js',
        clientInit: import.meta.server
            ? undefined
            : () => {

                let n = undefined
                const s = window;
                if (s.saq) return;
                n = s.saq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };

                if (!s._saq) s._saq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '1.0';
                n.queue = [];
            }
    })

    onLoaded((clickAd) => {
        saq('ts', clickads_token)
        // console.log('🚀 click ads pixel loaded', clickAd)
    })
}


const trigerClickAdsPayment = (data) => {

    const runtimeConfig = useRuntimeConfig()
    const { $country } = useNuxtApp()

    try {
        if (!$country.is_india) {
            !function (s, a, e, v, n, t, z) { if (s.saq) return; n = s.saq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!s._saq) s._saq = n; n.push = n; n.loaded = !0; n.version = '1.0'; n.queue = []; t = a.createElement(e); t.async = !0; t.src = v; z = a.getElementsByTagName(e)[0]; z.parentNode.insertBefore(t, z) }(window, document, 'script', 'https://tags.srv.stackadapt.com/events.js');

            saq('conv', runtimeConfig.public.clickads_payment_token, {
                'revenue': data.total_label,
                'order_id': '',
                'product_id ': ''
            });

            // console.log('click ads triggered on payment page')
        }
    }
    catch (error) {
        // console.log('error on clickads payment event', error)
    }
}


const trigerClickAdsCart = (data) => {
    const runtimeConfig = useRuntimeConfig()
    const { $country } = useNuxtApp()

    try {
        if (!$country.is_india) {
            !function (s, a, e, v, n, t, z) { if (s.saq) return; n = s.saq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!s._saq) s._saq = n; n.push = n; n.loaded = !0; n.version = '1.0'; n.queue = []; t = a.createElement(e); t.async = !0; t.src = v; z = a.getElementsByTagName(e)[0]; z.parentNode.insertBefore(t, z) }(window, document, 'script', 'https://tags.srv.stackadapt.com/events.js');

            saq('conv', runtimeConfig.public.clickads_cart_token, {
                'revenue': data.total,
                'order_id': '',
                'product_id ': ''
            });

            // console.log('click ads triggered on cart page')
        }
    }
    catch (error) {
        // console.log('error on clickads cart event', error)
    }
}



const trigerClickAdsThankyou = (data) => {
    const runtimeConfig = useRuntimeConfig()
    const { $country } = useNuxtApp()

    try {
        if (!$country.is_india) {
            !function (s, a, e, v, n, t, z) { if (s.saq) return; n = s.saq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!s._saq) s._saq = n; n.push = n; n.loaded = !0; n.version = '1.0'; n.queue = []; t = a.createElement(e); t.async = !0; t.src = v; z = a.getElementsByTagName(e)[0]; z.parentNode.insertBefore(t, z) }(window, document, 'script', 'https://tags.srv.stackadapt.com/events.js');

            saq('conv', runtimeConfig.public.clickads_checkout_token, {
                'revenue': data.total_label,
                'order_id': data.trans_id,
                'product_id': ''
            })

            // console.log('click ads triggered on thank you page')
        }
    }
    catch (error) {
        // console.log('error on clickads thankyou event', error)
    }
}


const triggerMixpanel = (event, data) => {
    return
    const runtimeConfig = useRuntimeConfig()
    const { $country, $mixpanel } = useNuxtApp()
    try {
        // console.log('mixpanel executed', $mixpanel)
        if (!$country.is_india && ![false, 'false'].includes(runtimeConfig.public.mixpanel_token)) {
            $mixpanel.track(event, data);
        }
    } catch (error) {
        console.log(error, 'error')
    }

}


const triggerPostHogEvent = (event, data) => {
    const { $posthog } = useNuxtApp()
    try {
        const posthog = $posthog()
        posthog.capture(event, { property: data })
    } catch (error) {
        console.log(error, 'posthog error')
    }

}



const trigerTTIdentity = (data) => {
    // console.log('tt identity executed')
    const { $country, $scripts } = useNuxtApp()

    try {

        if (!$country.is_india && $scripts.tiktok) {
            // console.log(data.address.email, 'ttq identity triggered')
            $scripts.tiktok.proxy.identify({
                "email": data.address.email,
                "phone_number": '+1' + data.address.shipping_phone,
            })

            // console.log('ttq identity triggered')
        }
    } catch (error) {
        console.log('error on ttq identity event', error)
    }
}



const trigerTT = (eventName, data) => {

    const { $country, $scripts } = useNuxtApp()
    try {

        if (!$country.is_india && $scripts.tiktok) {

            $scripts.tiktok.proxy.track(eventName, data)
            // ttq.track(eventName, data)
        }
    } catch (error) {

        console.log('error on ttq event', error)
    }

}

const initiateMetaPixel = () => {
    return
    const { $country } = useNuxtApp();
    const runtimeConfig = useRuntimeConfig();
    const isTagsEnabled = runtimeConfig.public.enable_tags === 'true'
    const meta_key = $country.location == 'US' ? 'metaPixelUS' : 'metaPixelUK'
    // const pixel_id = runtimeConfig.public.scripts[meta_key]?.id
    const pixel_id = $country.location == 'US' ? runtimeConfig.public.fbTag : runtimeConfig.public.fbTagUK
    const { user } = useSanctumAuth();

    // validate meta pixel key
    if (!meta_key || !isTagsEnabled || !pixel_id) {
        console.log("Meta Pixel key is missing or tags are disabled", meta_key, isTagsEnabled, pixel_id);
        return;
    }

    const { onLoaded } = useScriptMetaPixel({
        key: meta_key,
        id: pixel_id
    });

    // console.log('initiateMetaPixel meta pixel initiated', meta_key, isTagsEnabled, pixel_id)
    // return 
    onLoaded(({ fbq }) => {

        if (!fbq) {
            return
        }
        watch(
            () => user.value,
            async (newUser) => {
                if (!newUser) {
                    return;
                }
                const userData = {
                    em: await getSHA256Hash(newUser.email),
                    fn: await getSHA256Hash(newUser.first_name),
                    ln: await getSHA256Hash(newUser.last_name),
                    country: $country.location,
                };
                fbq('set', userData);
            },
        );

    });

};

const trigerfb = (eventName, data) => {

    // if (eventName != 'Purchase') {

    //     console.log('event skipped')
    //     return
    // }
    // console.log('event triggered start', eventName, data)


    const { $country } = useNuxtApp();
    const runtimeConfig = useRuntimeConfig();
    const isTagsEnabled = runtimeConfig.public.enable_tags === 'true'
    const meta_key = $country.location == 'US' ? 'metaPixelUS' : 'metaPixelUK'
    const pixel_id = runtimeConfig.public.scripts[meta_key]?.id

    // validate meta pixel key !meta_key || || !pixel_id 
    if (!isTagsEnabled) {
        console.log("trigerfb Meta Pixel key is missing or tags are disabled", isTagsEnabled);
        return;
    }

    // const { proxy } = useScriptMetaPixel({
    //     key: meta_key,
    //     id: pixel_id
    // });
    // console.log('trigerfb meta pixel initiated', meta_key, isTagsEnabled, pixel_id)

    try {
        let currentUrl = window?.location?.href
        $fetch(useCountryPath('/track', true), {
            method: 'POST',
            body: { eventName, data, currentUrl }
        })
        // proxy.fbq("trackCustom", eventName, data);
        // console.log('event triggered', eventName, data, 'pixel meta');

    } catch (error) {
        console.error('error on fbq event', error)
    }
    // console.log('event triggered end 1')
};


const initGoogleAds = () => {

    const runtimeConfig = useRuntimeConfig();
    const googleAd = runtimeConfig.public.scripts.googleAds.id;

    if ([false, 'false', undefined, 'undefined', null, ""].includes(googleAd)) {
        return
    }

    const { $country } = useNuxtApp();

    if ($country.location !== "UK") return;

    const googleAdsKey = runtimeConfig.public.scripts.googleAds.id;

    const { proxy, onLoaded } = useScript({
        key: "googleAds",
        id: googleAdsKey,
        trigger: "onNuxtReady",
        src: `https://www.googletagmanager.com/gtag/js?id=${googleAdsKey}`,
    });

    onLoaded(() => {

        window.dataLayer = window.dataLayer || [];

        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());

        window.gtag("config", googleAdsKey);

        console.log("Google Ads base tag initialized and configured.");
    });
};

const triggerGoogleAdsEvent = (event, eventName, params) => {
    try {
        if (typeof window.gtag !== "function") {
            console.warn("gtag not initialized yet. Pushing to dataLayer as fallback.");

            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
                event: event,
                eventName: eventName,
                ...params,
            });
            return;
        }

        window.gtag(event, eventName, params);
    } catch (error) {
        console.error("Error triggering Google Ads event:", error);
    }
};

const initCriteo = () => {
    const runtimeConfig = useRuntimeConfig();
    const { user } = useSanctumAuth();
    const criteoId = runtimeConfig.public.scripts.criteoId?.id;
    const { $device } = useNuxtApp();
    const enableCritieoTag = runtimeConfig.public.enable_criteo_tags === 'true';

    const getCriteoDeviceType = ($device) => {
        if ($device?.isTablet) return "t";
        if ($device?.isMobile) return "m";
        return "d";
    };
    const deviceType = getCriteoDeviceType($device);
    if ([false, 'false', undefined, 'undefined', null, ""].includes(criteoId)) {
        return
    }

    if (!enableCritieoTag) {
        console.log("Criteo tags are disabled. Init", enableCritieoTag);
        return;
    }


    const { proxy, onLoaded } = useScript({
        key: "criteo",
        id: criteoId,
        src: `//dynamic.criteo.com/js/ld/ld.js?a=${criteoId}`,
    });

    onLoaded(() => {
        if (!window.criteo_q) {
            console.log("Initializing window.criteo_q");
            window.criteo_q = [];
        }
        watch(
            () => user.value,
            async (newUser) => {
                if (!newUser) {
                    console.log("User is null — skipping Criteo homepage tag");
                    return;
                }

                if (window.criteo_q) {
                    window.criteo_q.push(
                        { event: "setAccount", account: criteoId },
                        { event: "setEmail", email: newUser.email },
                        { event: "setSiteType", type: deviceType },
                    );
                }

                console.log("Criteo init");
            }
        );
    });
};

const triggerCriteo = (event, params = {}) => {
    const runtimeConfig = useRuntimeConfig();
    const enableCritieoTag = runtimeConfig.public.enable_criteo_tags === 'true';
    const criteoId = runtimeConfig.public.scripts.criteoId?.id;
    const { $device } = useNuxtApp();
    const { user } = useSanctumAuth();


    const userEmail = computed(() => user?.value?.email ?? null);
    const getCriteoDeviceType = ($device) => {
        if ($device?.isTablet) return "t";
        if ($device?.isMobile) return "m";
        return "d";
    };
    const deviceType = getCriteoDeviceType($device);

    if (!enableCritieoTag) {
        console.log("Criteo tags are disabled. Init", enableCritieoTag);
        return;
    }

    try {
        if (typeof window === "undefined") {
            console.warn("Criteo event skipped: window is undefined (SSR).");
            return;
        }

        if (!window?.criteo_q) {
            console.warn("window.criteo_q not found — initializing");
            window.criteo_q = [];
        }

        const criteoEvent = {
            event, ...params,
            account: criteoId,
            email: userEmail?.value,
            deviceType: deviceType
        };

        window.criteo_q.push(
            { event: "setAccount", account: criteoId },
            { event: "setEmail", email: userEmail?.value },
            { event: "setSiteType", type: deviceType },
            { event: event, ...params }
        );
        
        console.log("Criteo event sent successfully:", criteoEvent);
    } catch (error) {
        console.error("Error triggering Criteo event:", error);
    }
};


export {
    initiateTikTokPixel,
    intiateClickAdsPixel,
    trigerClickAdsPayment,
    trigerClickAdsCart,
    trigerClickAdsThankyou,
    triggerMixpanel,
    initiateMetaPixel,
    triggerPostHogEvent,
    trigerTTIdentity,
    trigerTT,
    trigerfb,
    initGoogleAds,
    triggerGoogleAdsEvent,
    initCriteo,
    triggerCriteo
}